import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../context/axios";

const UserReviewsTablePage = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReviews = async () => {
      setLoading(true);
      setError("");
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        if (!user._id) throw new Error("User not logged in");

        const res = await axios.get(`/reviews/user/${user._id}`);
        setReviews(res.data);
      } catch (err) {
        setError(
          err.response?.data?.message || err.message || "Failed to load reviews"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  if (loading)
    return (
      <p className="text-center mt-10 text-green-700">
        Loading your reviews...
      </p>
    );
  if (error) return <p className="text-center mt-10 text-red-600">{error}</p>;
  if (reviews.length === 0)
    return (
      <div className="h-[90vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
      <img
        src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
        alt="No data"
        className="w-24 h-24 mb-4 opacity-70"
      />
     <h2 className="text-xl font-semibold text-gray-700 mb-2">
    No Reviews Yet
  </h2>
  <p className="text-gray-500 mb-4 max-w-md">
    You haven’t added any reviews yet. After completing your trips, share your experience and help other travelers!
  </p>
    </div>
    );

  return (
    <div className="overflow-x-auto p-6 w-screen">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">My Reviews</h1>

      <div className="overflow-x-auto rounded-lg shadow bg-white">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-green-100 text-green-800 uppercase tracking-wide">
          <tr className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-left">
                          <th className="px-4 py-3">Sr. No.</th>
              <th className="px-4 py-3">Tour Image</th>
              <th className="px-4 py-3">Tour Title</th>
              <th className="px-4 py-3">Price (€)</th>
              <th className="px-4 py-3">Review Title</th>
              <th className="px-4 py-3">Review Description</th>
              <th className="px-4 py-3 text-center">Rating</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review, index) => (
              <tr
                key={review._id}
                className="border-t  transition-colors duration-150"
              >
                <td className="px-4 py-3 text-center font-semibold text-gray-700">
                  {index + 1}
                </td>
                <td className="px-4 py-3 text-center">
                  <img
                    src={review.tour.img || "/default-tour.jpg"}
                    alt={review.tour.title}
                    className="w-20 h-16 object-cover rounded mx-auto"
                  />
                </td>
                <td className="px-4 py-3 font-medium text-gray-800">
                  {review.tour.title || "N/A"}
                </td>
                <td className="px-4 py-3 text-center text-gray-700">
                  {review.tour.price ? `€${review.tour.price}` : "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800">{review.title}</td>
                <td className="px-4 py-3 max-w-sm break-words text-gray-600">
                  {review.description}
                </td>
                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center space-x-1">
                    {[...Array(5)].map((_, i) => {
                      const starNum = i + 1;
                      return (
                        <svg
                          key={i}
                          className={`w-5 h-5 ${
                            starNum <= review.rating
                              ? "text-green-500"
                              : "text-gray-300"
                          }`}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.17c.969 0 1.371 1.24.588 1.81l-3.376 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.376-2.454a1 1 0 00-1.176 0l-3.376 2.454c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.045 9.394c-.783-.57-.38-1.81.588-1.81h4.17a1 1 0 00.95-.69l1.286-3.967z" />
                        </svg>
                      );
                    })}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserReviewsTablePage;

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const UserReviewsTablePage = () => {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchReviews = async () => {
//       setLoading(true);
//       setError("");
//       try {
//         const user = JSON.parse(localStorage.getItem("user") || "{}");
//         if (!user._id) throw new Error("User not logged in");

//         const res = await axios.get(`/reviews/user/${user._id}`);
//         setReviews(res.data);
//       } catch (err) {
//         setError(err.response?.data?.message || err.message || "Failed to load reviews");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchReviews();
//   }, []);

//   if (loading) return <p className="text-center mt-10">Loading your reviews...</p>;
//   if (error) return <p className="text-center mt-10 text-red-600">{error}</p>;

//   if (reviews.length === 0) return <p className="text-center mt-10">You have not posted any reviews yet.</p>;

//   return (
//     <div className="max-w-6xl mx-auto p-6">
//       <h1 className="text-3xl font-bold mb-5 ">My Reviews</h1>

//       <div className="overflow-x-auto">
//         <table className="min-w-full border border-gray-300 rounded">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="border border-gray-300 px-4 py-2">Tour Image</th>
//               <th className="border border-gray-300 px-4 py-2">Tour Title</th>
//               <th className="border border-gray-300 px-4 py-2">Price (€)</th>
//               <th className="border border-gray-300 px-4 py-2">Review Title</th>
//               <th className="border border-gray-300 px-4 py-2">Review Description</th>
//               <th className="border border-gray-300 px-4 py-2">Rating</th>
//             </tr>
//           </thead>
//           <tbody>
//             {reviews.map((review) => (
//               <tr key={review._id} className="hover:bg-gray-50">
//                 <td className="border border-gray-300 px-4 py-2 text-center">
//                   <img
//                     src={review.tour.img || "/default-tour.jpg"}
//                     alt={review.tour.title}
//                     className="w-20 h-16 object-cover rounded mx-auto"
//                   />
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2 font-semibold">
//                   {review.tour.title || "N/A"}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2 text-center">
//                   {review.tour.price ? `€${review.tour.price}` : "N/A"}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2 font-semibold">{review.title}</td>
//                 <td className="border border-gray-300 px-4 py-2 max-w-xs break-words">{review.description}</td>
//                 <td className="border border-gray-300 px-4 py-2 text-center">
//                   <div className="flex justify-center space-x-1">
//                     {[...Array(5)].map((_, i) => {
//                       const starNum = i + 1;
//                       return (
//                         <svg
//                           key={i}
//                           className={`w-5 h-5 ${
//                             starNum <= review.rating ? "text-yellow-400" : "text-gray-300"
//                           }`}
//                           fill="currentColor"
//                           viewBox="0 0 20 20"
//                         >
//                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.17c.969 0 1.371 1.24.588 1.81l-3.376 2.455a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.376-2.454a1 1 0 00-1.176 0l-3.376 2.454c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118L2.045 9.394c-.783-.57-.38-1.81.588-1.81h4.17a1 1 0 00.95-.69l1.286-3.967z" />
//                         </svg>
//                       );
//                     })}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default UserReviewsTablePage;
